// CostEstimatePdf
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import './CostEstimate.css';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

import costEstimateService from '../../features/costestimate/costEstimateService';
import commonService from '../../features/common/commonService';
import authService from '../../features/auth/authService';
import { toast } from 'react-toastify';
import Spinner from '../Layout/Spinner';
import pdfService from '../../features/pdf/pdfService';
import moment from 'moment';
import { indexBy } from 'underscore';
import utc from 'dayjs/plugin/utc'; 


dayjs.extend(utc);



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,

}));

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

isNumber(12)


function CostEstimate(props) {

  let [costEstimateData, setCostEstimateData] = useState({});
  const [emailError, setEmailError] = useState('');
  let [isLoading, setIsLoading] = useState(false);
  let [total, setTotal] = useState(0);
  let [credit, setCredit] = useState(0);

  useEffect(() => {
    document.title = props.title

    setIsLoading(true)
    costEstimateService.getCSPageDate({ districtId: authService.getDist(), userId: authService.getUserId(), academicyear: localStorage.getItem("academicyear"), selectedyear: localStorage.getItem("selectedYear") || "2026-2027" }).then((result) => {
      result.data.costestimateData['CalSCHLS Credits'] = result.data.costestimateData['CalSCHLS Credits'].map(e => {
        e.value = e.value.toFixed(2)
        return e
      })

      // console.log(result.data);
      console.log("result.data.costEstimateOrderDate",result.data.costEstimateOrderDate)
      result.data.costEstimateOrderDate = result.data.costEstimateOrderDate.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}/, "T15:00:00.000");
      console.log("result.data.costEstimateOrderDateeeeee",result.data.costEstimateOrderDate)
      setCostEstimateData(result.data);

      // console.log(result.data);
      setIsLoading(false)
    }).catch(err => {
      if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Unable to fetch cost estimate data. Please try again later.");
      }
      setIsLoading(false)
    })

  }, []);

  useEffect(() => {
    calculateTotal();
  }, [costEstimateData, credit, total])


  const handleOnChange = (event) => {
    const { name, value } = event.target;
    // console.log(name, value)
    setCostEstimateData({ ...costEstimateData, [name]: value });
  };

  const handleEmailOnChange = (event) => {
    const { name, value } = event.target;

    // Regular expression for email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Allow clearing the input field
    setCostEstimateData({ ...costEstimateData, [name]: value });

    // Validate email only if there is a value
    if (value === '') {
      setEmailError('');
    } else if (!emailPattern.test(value)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleCSOnChange = (event) => {
    // Do something with the updated textbox value and name
    const { name, value } = event.target;
    // console.log(name, value);
    const headerdata = event.target.getAttribute('headerdata');
    const datatype = event.target.getAttribute('datatype');

    const regex = /^\d+(\.\d{0,2})?$/;
    if (regex.test(value) || value === '') {

      let costEstNew = costEstimateData.costestimateData[headerdata]
      costEstNew.map((val, key) => {
        if (val.name === name) {
          if (datatype === "value") {
            val.value = value
          }

          if (datatype === "unitPrice") {
            val.unitPrice = value
          }
        }
      });
      // console.log(costEstNew);
      setCostEstimateData({ ...costEstimateData, ["costEstimateData.costestimateData"]: costEstNew });

    }
  };

  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const saveCostEstimateData = () => {
    let containChar = false;
    console.log(costEstimateData)

    for (let key in costEstimateData.costestimateData) {
      console.log(key)
      let csData = costEstimateData.costestimateData[key];
      for (var i = 0; i < csData.length; i++) {
        if (csData[i].unitPrice && csData[i].value) {
          if (!isNumber(csData[i].unitPrice) || !isNumber(csData[i].value)) {
            containChar = true;
          }
        }
        if (!csData[i].unitPrice) {
          csData[i].unitPrice = 0
        }

        if (!csData[i].value) {
          csData[i].value = 0
        }
      }
    }

    if (!costEstimateData.costEstimateOrderDate) {
      toast.error("Please provide order report date")
    } else if (!costEstimateData.costCode) {
      toast.error("Please provide Cost Code")
    } else if (containChar) {
      toast.error("Please provide numeric value")
    } else {
      setCostEstimateData(costEstimateData);
      setIsLoading(true);
      costEstimateService.saveCSPageData({ ...costEstimateData, districtId: authService.getDist() }).then((result) => {
        toast.success("Cost Estimate Data saved successfully");
        
      //   setTimeout(() => {
      //     window.location.reload();
      // }, 3000);
        setIsLoading(false);
      }).catch((err) => {
        toast.error(err.message ? err.message : "Error is saving costestimate data. Please try again later")
        setIsLoading(false);


      })
    }
  }

  const calculateTotal = () => {
    let total = 0;
    let credit = 0;
    // console.log("checking calculation")
    if (costEstimateData && costEstimateData.costestimateData) {

      for (let item in costEstimateData.costestimateData) {

        if (item !== "CalSCHLS Credits") {
          for (let data of costEstimateData.costestimateData[item]) {
            total = total + (data.value * data.unitPrice)
          }
        }

        if (item === "CalSCHLS Credits") {
          for (let data of costEstimateData.costestimateData[item]) {
            let val = data.value ? parseFloat(data.value) : 0;
            credit = credit + val
          }
        }

      }

    }
    setCredit(credit)
    setTotal(total)
  }

  const formatPhoneNumber = (phoneNumber) => {
      const cleaned = ('' + phoneNumber).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      
      if (match) {
          return `${match[1]}-${match[2]}-${match[3]}`;
      }

      return phoneNumber;
  };

  const getAcademicYearFormatted = async () => {
    let academicYearId = localStorage.getItem("academicyear");
    let formattedYear;

    try {
        const response = await commonService.getAcademicYearById(academicYearId);
        if (response && response.academicYear) {
            const academicYear = response.academicYear.year;
            const startYear = academicYear.split('-')[0].slice(-2); // Get last two digits of the first year
            const endYear = academicYear.split('-')[1].slice(-2);
            formattedYear = startYear + endYear;
        } else {
            console.error("Academic year not found in the response.");
        }
    } catch (error) {
        console.error("Error fetching academic year:", error);
    }

    return formattedYear;
  };

  const downloadCSPdf = async () => {
    setIsLoading(true)
    console.log('districttoken', localStorage.getItem('districtId'));
    let formattedYear = await getAcademicYearFormatted();
    
    if (!formattedYear) {
      console.error("Formatted year not available.");
      return ""; 
    }
    console.log("formattedYear - report:", formattedYear);
  
    pdfService.downloadpdf('costestimatepdf', {
      // districtId: authService.getDist(),
      districtId: localStorage.getItem('districtId'),
      userId: authService.getUserId(),
      academicyear:localStorage.getItem('academicyear'),
      selectedYear:localStorage.getItem('selectedYear'),
      token: encodeURIComponent(authService.getToken())
      // token: encodeURIComponent('64b52eda4c32df5b481f9f46')
    }, `CostEstimates_${formattedYear}_${(costEstimateData.districtName).replaceAll(' ', '')}`).then((response) => {
      setIsLoading(false)
      console.log(response)
    }).catch((err) => {
      console.log(err)
    })
  }
  function formatDate(date) {
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getUTCFullYear();
    return `${month}-${day}-${year}`;
}
  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
      <div className='pageHeader'>
        {/* <div className="pageText">Cost Estimate</div> */}
      </div>
      <Grid>
        <Item style={{ padding: '0' }} className='mainCard'>

          <div className='titleClass'>
            <span style={{ width: '80%', position: 'relative', left: '5%' }}>
              <img className='schoolClimate' src={require('../../assets/images/costEstimate.png')} alt='School climate health'></img>
              <p className='salesQuote'> {(costEstimateData && costEstimateData.csTitle) ? costEstimateData.csTitle : ''} </p>
              {authService.getRole() === 'admin' ? (
              localStorage.getItem("academicyear") === 'currentyear' ? (
                <input value={(costEstimateData && costEstimateData.csSubTitle) ? costEstimateData.csSubTitle : ""} className='salesQuoteText' autoComplete='off' type='text' name="csSubTitle" onChange={handleOnChange} />
              ) : (
                <input value={(costEstimateData && costEstimateData.csSubTitle) ? costEstimateData.csSubTitle : ""} className='salesQuoteText' autoComplete='off' type='text' name="csSubTitle" onChange={handleOnChange} disabled />
              )
            ) : (
              <span style={{ color: '#003c68', fontSize: '19px' }}>
                {(costEstimateData && costEstimateData.csSubTitle) ? costEstimateData.csSubTitle : "Do not pay off this Sales Quote"}
              </span>
            )}

            </span>

            {authService.getRole() === 'admin' ? (
              <span>
                <Button style={{ marginTop: '50px' }} onClick={downloadCSPdf}>
                  <img className='pdfImage' src={require('../../assets/images/downloadpdf_new.png')} alt='Download Pdf'></img>
                </Button>
              </span>
            ) : 
            <div style={{ marginLeft: '105px' }} ></div>
            }
          </div>

          {/* <div className='dateClass'> */}
            {authService.getRole() == 'admin' && localStorage.getItem("academicyear") === 'currentyear' ? 
            <div className='dateClass'>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker 
                  label="Date"
                  // value={costEstimateData && costEstimateData.costEstimateOrderDate ? dayjs(costEstimateData.costEstimateOrderDate) : dayjs(new Date())}
                  value={costEstimateData && costEstimateData.costEstimateOrderDate ? dayjs.utc(costEstimateData.costEstimateOrderDate).startOf('day') : dayjs(new Date())}
                  // onChange={(newValue) => costEstimateDate(newValue)}
                  onChange={(date) => {
                    const d = new Date(date);
                    setCostEstimateData({ ...costEstimateData, ["costEstimateOrderDate"]: d });
                  }}
                />
              </LocalizationProvider>
              </div>
              // : <span><span className='orderTextTitle'>Date: </span><span>{costEstimateData && costEstimateData.costEstimateOrderDate ? costEstimateData.costEstimateOrderDate : moment(new Date()).format('DD-MM-YYYY')}</span></span>
              : 
              <div className='dateClass_dc'>
                <span>
              <span className='orderTextTitle'>Date: </span>
              <span>
                {costEstimateData.costEstimateOrderDate === "NA"
                  ? "NA"
                  : formatDate(new Date(costEstimateData.costEstimateOrderDate))}
              {/* {costEstimateData && costEstimateData.costEstimateOrderDate 
                  ? formatDate(new Date(costEstimateData.costEstimateOrderDate))
                  : formatDate(new Date())
                } */}
              {/* {costEstimateData && costEstimateData.costEstimateOrderDate
                ? formatDate(new Date(costEstimateData.costEstimateOrderDate))
                : (localStorage.getItem('academicyear') === '6846a42d545ed2bf5ae0ca99' 
                    ? formatDate(new Date()) 
                    : 'NA')
              } */}
            
              </span>
            </span>
            </div>
            }
          {/* </div> */}


          <TableContainer>
            <Table style={{ marginBottom: '15px' }}>

              <TableRow>

                <TableCell className='bodyStyles'>
                  <div className='billBasicDetailsHeader'>Bill To:	</div>
                </TableCell>

                <TableCell className='bodyStyles2'>
                  <div style={{ paddingBottom: '5px' }} className='billBasicDetailsHeader2'>Remit To: </div>
                </TableCell>

              </TableRow>

              <TableRow>

                <TableCell className='bodyStylesContent'>
                  <div className='billBasicDetailsBody'>
                    {(costEstimateData && costEstimateData.districtName) ? costEstimateData.districtName : ''}<br />
                    {(costEstimateData && costEstimateData.dcName) ? costEstimateData.dcName : ''}<br />
                    {(costEstimateData && costEstimateData.csAddress) ? costEstimateData.csAddress : ''}, {(costEstimateData && costEstimateData.csCity) ? costEstimateData.csCity : ''}, CA {(costEstimateData && costEstimateData.csZipCode) ? costEstimateData.csZipCode : ''}<br />
                  </div>
                </TableCell>

                <TableCell className='bodyStylesContent2'>
                  {/* {costEstimateData && costEstimateData.remitTo == 1 ?

                    <div className='billBasicDetailsBody'>
                      Duerr Evaluation Resources<br></br>
                      PO Box 674<br></br>
                      Durham, CA 95938<br></br>
                    </div>

                    :  */}
                    <div className='billBasicDetailsBody'>
                      WestEd<br></br> Attn: WestEd Operating Account<br></br>
                      P.O. Box 889001<br></br>
                      Los Angeles, CA 90088-9001<br></br>
                    </div>
                    {/* } */}
                </TableCell>

              </TableRow>

              <TableRow>

                <TableCell className='bodyStyles'>
                  <div style={{ paddingBottom: '5px' }} className='billBasicDetailsHeader'>Email:</div> 
                </TableCell>

                <TableCell className='bodyStyles2'>
                  <div style={{ paddingBottom: '5px' }} className='billBasicDetailsHeader2'>Cost Code #:</div>
                </TableCell>

              </TableRow>

              <TableRow>

                <TableCell className='bodyStylesContent'>
                  <div className='billBasicDetailsBody'>{(costEstimateData && costEstimateData.userEmail) ? costEstimateData.userEmail : ''}</div>
                </TableCell>

                <TableCell className='bodyStylesContent2'>
                <div className='billBasicDetailsBody'>
                  {authService.getRole() === 'admin' ? (
                    localStorage.getItem("academicyear") === 'currentyear' ? (
                      <input className='costCode' autoComplete='off' type='text' onChange={handleOnChange} name="costCode" value={(costEstimateData && costEstimateData.costCode) ? costEstimateData.costCode : ""} />
                    ) : (
                      <input className='costCode' autoComplete='off' type='text' onChange={handleOnChange} name="costCode" value={(costEstimateData && costEstimateData.costCode) ? costEstimateData.costCode : ""} disabled />
                    )
                  ) : (
                    <span>{(costEstimateData && costEstimateData.costCode) ? costEstimateData.costCode : ""}</span>
                  )}
                </div>
              </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className='bodyStyles'>
                  <div className='bigTextField'>
                    {authService.getRole() === 'admin' ? (
                      localStorage.getItem("academicyear") === 'currentyear' ? (
                        <>
                          <input value={(costEstimateData && costEstimateData.emailExtra) ? costEstimateData.emailExtra : ''} name="emailExtra" onChange={handleEmailOnChange} autoComplete='off' className='bigText' type='text' />
                          {emailError && <div className='error'>{emailError}</div>}
                        </>
                      ) : (
                        <input value={(costEstimateData && costEstimateData.emailExtra) ? costEstimateData.emailExtra : ''} name="emailExtra" onChange={handleEmailOnChange} autoComplete='off' className='bigText' type='text' disabled />
                      )
                    ) : null}
                  </div>
                  <div style={{ paddingBottom: '5px' }} className='billBasicDetailsHeader'>Phone No:</div>
                </TableCell>

                <TableCell className='bodyStyles2'>
                </TableCell>

              </TableRow>

              <TableRow>

                <TableCell className='bodyStylesContent'>
                  <div className='billBasicDetailsBody'>{(costEstimateData && costEstimateData.phoneNumber) ? formatPhoneNumber(costEstimateData.phoneNumber) : ''}<br />
                  </div>
                </TableCell>

                <TableCell className='bodyStylesContent2'>
                <div className='bigTextField'>
                  {authService.getRole() === 'admin' ? (
                    localStorage.getItem("academicyear") === 'currentyear' ? (
                      <input value={(costEstimateData && costEstimateData.costEstimateExtra) ? costEstimateData.costEstimateExtra : ""} name="costEstimateExtra" onChange={handleOnChange} autoComplete='off' className='bigText' type='text' />
                    ) : (
                      <input value={(costEstimateData && costEstimateData.costEstimateExtra) ? costEstimateData.costEstimateExtra : ""} name="costEstimateExtra" onChange={handleOnChange} autoComplete='off' className='bigText' type='text' disabled />
                    )
                  ) : 
                  <input value={(costEstimateData && costEstimateData.costEstimateExtra) ? costEstimateData.costEstimateExtra : ""} name="costEstimateExtra" onChange={handleOnChange} autoComplete='off' className='bigText' type='text' disabled />
                  }
                </div>
              </TableCell>

              </TableRow>

            </Table>
          </TableContainer>


          <TableContainer className='dateClass1'>
            <Table >
              <TableRow >
                <TableCell className='standtardStyleSchool_ce' style={{ width: '36%' }}>
                  {/* <span > */}
                  <span style={{ width: '100%' }} ref={el => {
                    if (el) {
                      el.style.setProperty('text-align', 'left', 'important');
                    }
                  }}>Item Description</span>
                </TableCell>
                <TableCell style={{ width: '15.5%' }} className='standtardStyleSchool_ce'>
                  <span style={{ width: '100%' }}>Quantity</span>
                </TableCell>
                <TableCell style={{ width: '26%' }} className='standtardStyleSchool_ce'>
                  <span style={{ width: '100%' }}>Unit Price</span>
                </TableCell>
                <TableCell style={{ width: '15.5%', borderStyle: 'none' }} className='standtardStyleSchool_ce'>
                  <span style={{ width: '100%' }}>Amount</span>
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>

          <TableContainer component={Paper}>
            <Table aria-label="sticky table" className='tableStyle'>
              {/* CHKS Basic Administration integration */}
              <>
                <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>

                  <TableCell className='tableRow1Text' ref={el => {
                    if (el) {
                      el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                    }
                  }}
                    style={{ fontSize: '1.2em', fontWeight: '500', color: '#003c68', borderBottom: 'none' }}>
                    CHKS Basic Administration
                  </TableCell>
                </TableRow >

                {
                  (costEstimateData && costEstimateData.costestimateData) ?
                    costEstimateData.costestimateData["CHKS Basic Administration"].map((innerElement, index) => (

                      <TableRow key={index}>
                        <TableCell className='textColorTable' ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px 4px 40px', 'important');
                          }
                        }} style={{ borderBottom: 'none', width: '36%' }}>
                          {innerElement['name']}
                        </TableCell>

                        {authService.getRole() === 'admin' ? (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 45px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '21.5%', textAlign: 'center' }}
                          >
                            {localStorage.getItem("academicyear") === 'currentyear' ? (
                              <input value={innerElement['value']} headerdata="CHKS Basic Administration" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                            ) : (
                              <input disabled value={innerElement['value']} headerdata="CHKS Basic Administration" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' />
                            )}
                          </TableCell>
                        ) : (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 13% 0px 10px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '21.5%', textAlign: 'center' }}
                          >
                            <span>{innerElement['value']}</span>
                          </TableCell>
                        )}

                        {authService.getRole() === 'admin' ? (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 9px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '16%', textAlign: 'center' }}
                          >
                            <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                            {
                              localStorage.getItem("academicyear") === 'currentyear' ? (
                                <input value={innerElement['unitPrice']} headerdata="CHKS Basic Administration" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                              ) : (
                                <input disabled value={innerElement['unitPrice']} headerdata="CHKS Basic Administration" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                              )
                            }
                          </TableCell>
                        ) : (
                          <TableCell
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty('padding', '4px 9px', 'important');
                                el.style.setProperty('margin', '0px auto', 'important');
                              }
                            }}
                            style={{
                              borderBottom: 'none',
                              width: '15.5%',
                              textAlign: 'center'
                            }}
                          >
                            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                              <div style={{ width: '60%', position: 'relative', bottom: '1px' }}>
                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                              </div>
                              <div style={{ width: '40%', textAlign: 'right' }}>
                                <span
                                  style={{
                                    textAlign: 'right',
                                    marginLeft: '5px',
                                    flex: '1',
                                    minWidth: '0',
                                  }}
                                >
                                  {innerElement['unitPrice']}
                                </span></div>
                              <div ><span style={{ width: '40%', fontWeight: '400', color: 'black', whiteSpace: 'nowrap', textAlign: 'right', marginRight: '5px' }} >
                                $
                              </span></div>
                            </div>
                          </TableCell>
                        )}

                        <TableCell
                          ref={el => {
                            if (el) {
                              el.style.setProperty('padding', '4px 9px', 'important');
                            }
                          }}
                          style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>

                          <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                              <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                            </div>
                            <div style={{ width: '40%', textAlign: 'right' }}>
                              {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                            </div>
                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                              <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                            </div>

                          </div>

                        </TableCell>
                      </TableRow>

                    ))
                    : ""
                }
              </>
              {/* CHKS Basic Administration integration end */}


              {/* CHKS Reporting */}
              <>
                <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>

                  <TableCell className='tableRow1Text' ref={el => {
                    if (el) {
                      el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                    }
                  }}
                    style={{ fontSize: '1.2em', fontWeight: '400', color: '#003c68', borderBottom: 'none' }}>
                    CHKS Reporting
                  </TableCell>
                </TableRow >

                {
                  (costEstimateData && costEstimateData.costestimateData) ?
                    costEstimateData.costestimateData["CHKS Reporting"].map((innerElement, index) => (

                      <TableRow key={index}>

                        <TableCell className='textColorTable' ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px 4px 40px', 'important');
                          }
                        }} style={{ borderBottom: 'none', width: '36%' }}>
                          {innerElement['name']}
                        </TableCell>


                        {authService.getRole() === 'admin' ? (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 45px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}
                          >
                            {localStorage.getItem("academicyear") === 'currentyear' ? (
                              <input value={innerElement['value']} headerdata="CHKS Reporting" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                            ) : (
                              <input disabled value={innerElement['value']} headerdata="CHKS Reporting" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                            )}
                          </TableCell>
                        ) : (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 13% 0px 10px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}
                          >
                            <span>{innerElement['value']}</span>
                          </TableCell>
                        )}

                      {
                        authService.getRole() === 'admin' ? (
                          <TableCell
                            ref={el => {
                              if (el) {
                                el.style.setProperty('padding', '4px 9px', 'important');
                              }
                            }}
                            style={{ borderBottom: 'none', width: '26%', textAlign: 'center' }} >
                            <div style={{ position: innerElement['name'] === "Other Customized Reports" ? 'relative' : '', right: innerElement['name'] === "Other Customized Reports" ? '13%' : '' }}>
                              <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                              {
                                localStorage.getItem("academicyear") === 'currentyear' ? (
                                  <input value={innerElement['unitPrice']} headerdata="CHKS Reporting" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                                ) : (
                                  <input disabled value={innerElement['unitPrice']} headerdata="CHKS Reporting" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                                )}
                              {innerElement['name'] === "Other Customized Reports" && " / hour rate"}
                            </div>
                          </TableCell>
                        ) : (
                          <TableCell
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty('padding', '4px 9px', 'important');
                                el.style.setProperty('margin', '0px auto', 'important');
                              }
                            }}
                            style={{
                              borderBottom: 'none',
                              width: '15.5%',
                              textAlign: 'center'
                            }}
                          >
                            <div
                              style={{
                                position: innerElement['name'] === 'Other Customized Reports' ? 'relative' : '',
                                right: innerElement['name'] === 'Other Customized Reports' ? '0%' : '',
                                display: 'flex', flexDirection: 'row-reverse'
                              }}
                            >
                              <div style={{ textAlign: 'left', width: '60%', position: 'relative', bottom: '1px' }}>
                                <span style={{ marginRight: '2px', position: 'relative' }}>
                                  {innerElement['name'] === 'Other Customized Reports' && (
                                    <span style={{ marginLeft: '4px'}}> / hour rate</span>
                                  )}
                                </span>
                              </div>
                              <div style={{ width: '40%', textAlign: 'right' }}>
                                <span
                                  style={{
                                    textAlign: 'right',
                                    marginLeft: '5px',
                                    flex: '1',
                                    minWidth: '0'
                                  }}
                                >
                                  {innerElement['unitPrice']}
                                </span>

                              </div>
                              <div>
                                <span
                                  style={{ width: '40%', fontWeight: '400', color: 'black', whiteSpace: 'nowrap', textAlign: 'right' }}>
                                  $
                                </span>
                              </div>


                            </div>

                          </TableCell>
                        )
                      }

                      < TableCell
                          ref = { el => {
                            if (el) {
                  el.style.setProperty('padding', '4px 9px', 'important');
                            }
                          }}
                style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>


                <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                  <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                  </div>
                  <div style={{ width: '40%', textAlign: 'right' }}>
                    {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                  </div>
                  <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                  </div>

                </div>

              </TableCell>

            </TableRow>

            ))
            : ""
                }
          </>
          {/*CHKS Reporting integration end */}



          {/* New Custom Module */}
          <>
            <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>

              <TableCell className='tableRow1Text' ref={el => {
                if (el) {
                  el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                }
              }}
                style={{ fontSize: '1.2em', fontWeight: '400', color: '#003c68', borderBottom: 'none' }}>
                New Custom Module
              </TableCell>
            </TableRow >

            {
              (costEstimateData && costEstimateData.costestimateData) ?
                costEstimateData.costestimateData["New Custom Module"].map((innerElement, index) => (

                  <TableRow key={index}>
                    <TableCell className='textColorTable' ref={el => {
                      if (el) {
                        el.style.setProperty('padding', '4px 9px 4px 40px', 'important');
                      }
                    }} style={{ borderBottom: 'none', width: '36%' }}>
                      {innerElement['name']}
                    </TableCell>

                    {authService.getRole() === 'admin' ? (
                    <TableCell
                      ref={el => {
                        if (el) {
                          el.style.setProperty('padding', '4px 45px', 'important');
                        }
                      }}
                      style={{ borderBottom: 'none', width: '16%', textAlign: 'center' }} >
                     
                     {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input value={innerElement['value']} headerdata="New Custom Module" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        ) : (
                          <input disabled value={innerElement['value']} headerdata="New Custom Module" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        )}</TableCell>
                      ) : (
                        <TableCell
                        ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 13% 0px 10px', 'important');
                          }
                        }}
                        style={{ borderBottom: 'none', width: '16%', textAlign: 'center' }} >
                       
                        <span>{innerElement['value']}</span>
                        </TableCell>
                      )}

                    {authService.getRole() === 'admin' ? (
                      <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 9px', 'important'); } }} style={{ borderBottom: 'none', width: '26%', textAlign: 'center' }} >
                        <div style={{ position: 'relative', right: '15.5%' }}>
                          <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>

                          {localStorage.getItem("academicyear") === 'currentyear' ? (
                            <input value={innerElement['unitPrice']} headerdata="New Custom Module" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                          ) : (
                            <input disabled value={innerElement['unitPrice']} headerdata="New Custom Module" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                          )}
                          {' / 3 questions'}
                        </div>
                      </TableCell>
                    ) : (
                      <TableCell
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                            el.style.setProperty('margin', '0px auto', 'important');
                          }
                        }}
                        style={{
                          borderBottom: 'none',
                          width: '15.5%',
                          textAlign: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>

                          <div style={{ textAlign: 'left', width: '60%', position: 'relative', bottom: '1px' }}>
                            <span style={{ marginRight: '2px', position: 'relative' }}>
                              <span style={{ marginLeft: '4px'}}> / 3 questions</span>
                            </span>
                          </div>
                          <div style={{ width: '40%', textAlign: 'right' }}>
                            <span
                              style={{
                                textAlign: 'right',
                                marginLeft: '5px',
                                flex: '1',
                                minWidth: '0',
                              }}
                            >
                              {innerElement['unitPrice']}
                            </span>
                          </div>
                          <div>
                            <span
                              style={{
                                fontWeight: '400',
                                color: 'black',
                                whiteSpace: 'nowrap',
                                textAlign: 'right',
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </TableCell>)}


                    <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 9px', 'important'); } }}
                      style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>
                      <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>
                        <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                        </div>
                        <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>

                ))
                : ""
            }
          </>
          {/*New Custom Module integration end */}



          {/* CSSS Administration */}
          <>
            <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>
              <TableCell className='tableRow1Text' ref={el => { if (el) { el.style.setProperty('padding', '5px 5px 5px 13px', 'important'); } }} style={{ fontSize: '1.2em', fontWeight: '400', color: '#003c68', borderBottom: 'none' }}> CSSS Administration </TableCell>
            </TableRow >
            {
              (costEstimateData && costEstimateData.costestimateData) ?
                costEstimateData.costestimateData["CSSS Administration"].map((innerElement, index) => (
                  <TableRow key={index}>
                    <TableCell className='textColorTable' ref={el => { if (el) { el.style.setProperty('padding', '4px 9px 4px 40px', 'important'); } }} style={{ borderBottom: 'none', width: '36%' }}> {innerElement['name']}
                    </TableCell>
                    {authService.getRole() === 'admin' ? (
                    <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 45px', 'important'); } }} style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }} >
                      { localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input value={innerElement['value']} headerdata="CSSS Administration" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        ) : (
                          <input disabled value={innerElement['value']} headerdata="CSSS Administration" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        )}
                        </TableCell>
                      ) : (
                        <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 13% 0px 10px', 'important'); } }} style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }} >
                        <span>{innerElement['value']}</span>
                        </TableCell>
                      )}
                   

                    {authService.getRole() === 'admin' ? (

                      <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 9px', 'important'); } }} style={{ borderBottom: 'none', width: '26%', textAlign: 'center' }} >
                        <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                        {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input value={innerElement['unitPrice']} headerdata="CSSS Administration" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                        ) : (
                          <input disabled value={innerElement['unitPrice']} headerdata="CSSS Administration" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                        )}
                      </TableCell>
                    ) : (
                      <TableCell
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                            el.style.setProperty('margin', '0px auto', 'important');
                          }
                        }}
                        style={{
                          borderBottom: 'none',
                          width: '15.5%',
                          textAlign: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                          <div style={{ width: '60%', position: 'relative', bottom: '1px' }}>
                            <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                          </div>
                          <div style={{ width: '40%', textAlign: 'right' }}>
                            <span
                              style={{
                                textAlign: 'right', marginLeft: '5px', flex: '1', minWidth: '0'
                              }}
                            >
                              {innerElement['unitPrice']}
                            </span>
                          </div>
                          <div>
                            <span style={{ width: '40%', fontWeight: '400', color: 'black', whiteSpace: 'nowrap', textAlign: 'right', marginRight: '2px' }} >
                              $
                            </span>
                          </div>
                        </div>
                      </TableCell>
                    )}

                    <TableCell
                      ref={el => {
                        if (el) {
                          el.style.setProperty('padding', '4px 9px', 'important');
                        }
                      }}
                      style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>

                      <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                        <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                        </div>
                        <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>

                ))
                : ""
            }
          </>
          {/*CSSS Administration integration end */}


          {/* CSPS Administration */}
          <>
            <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>

              <TableCell className='tableRow1Text' ref={el => {
                if (el) {
                  el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                }
              }}
                style={{ fontSize: '1.2em', fontWeight: '400', color: '#003c68', borderBottom: 'none' }}>
                CSPS Administration
              </TableCell>
            </TableRow >

            {
              (costEstimateData && costEstimateData.costestimateData) ?
                costEstimateData.costestimateData["CSPS Administration"].map((innerElement, index) => (

                  <TableRow key={index} >
                    <TableCell className='textColorTable' ref={el => {
                      if (el) {
                        el.style.setProperty('padding', '4px 9px 4px 40px', 'important');
                      }
                    }} style={{ borderBottom: 'none', width: '36%' }}>
                      {innerElement['name']}
                    </TableCell>

                    {authService.getRole() === 'admin' ? (
                    <TableCell
                      ref={el => {
                        if (el) {
                          el.style.setProperty('padding', '4px 45px', 'important');
                        }
                      }}
                      style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}
                    >
                        {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input
                            value={innerElement['value']}
                            headerdata="CSPS Administration"
                            datatype="value"
                            name={innerElement['name']}
                            className='inputForTable_ceQuan'
                            type='text'
                            onChange={handleCSOnChange}
                          />
                        ) : (
                          <input
                            disabled
                            value={innerElement['value']}
                            headerdata="CSPS Administration"
                            datatype="value"
                            name={innerElement['name']}
                            className='inputForTable_ceQuan'
                            type='text'
                            onChange={handleCSOnChange}
                          />
                        )}</TableCell>
                      ) : (
                        <TableCell
                        ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 13% 0px 10px', 'important');
                          }
                        }}
                        style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}
                      >
                        <span>{innerElement['value']}</span>
                        </TableCell>
                      )}
                    

                    {authService.getRole() === 'admin' ? (
                      <TableCell
                        ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                          }
                        }}
                        style={{ borderBottom: 'none', width: '26%', textAlign: 'center' }}
                      >
                        <span
                          style={{
                            marginRight: '2px',
                            fontWeight: '400',
                            color: 'black',
                            position: 'relative',
                            top: '2px'
                          }}
                        >
                          $
                        </span>
                        {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input
                            value={innerElement['unitPrice']}
                            headerdata="CSPS Administration"
                            datatype="unitPrice"
                            name={innerElement['name']}
                            className='inputForTable_ceUP'
                            type='text'
                            onChange={handleCSOnChange}
                          />
                        ) : (
                          <input
                            disabled
                            value={innerElement['unitPrice']}
                            headerdata="CSPS Administration"
                            datatype="unitPrice"
                            name={innerElement['name']}
                            className='inputForTable_ceUP'
                            type='text'
                            onChange={handleCSOnChange}
                          />
                        )}
                      </TableCell>
                    ) : (

                      <TableCell
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                            el.style.setProperty('margin', '0px auto', 'important');
                          }
                        }}
                        style={{
                          borderBottom: 'none',
                          width: '15.5%',
                          textAlign: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                          <div style={{ width: '60%', position: 'relative', bottom: '1px' }}>
                            <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                          </div>
                          <div style={{ width: '40%', textAlign: 'right' }}>
                            <span
                              style={{
                                textAlign: 'right',
                                marginLeft: '5px',
                                flex: '1',
                                minWidth: '0'
                              }}
                            >
                              {innerElement['unitPrice']}
                            </span>
                          </div>
                          <div>
                            <span
                              style={{
                                width: '40%',
                                fontWeight: '400',
                                color: 'black',
                                whiteSpace: 'nowrap',
                                textAlign: 'right',
                                marginRight: '2px',
                                position: 'relative',
                                top: '2px'
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </TableCell>
                    )}
                    <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 9px', 'important'); } }} style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>
                      <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>
                        <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                        </div>
                        <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>

                ))
                : ""
            }
          </>
          {/*CSSS Administration integration end */}



          {/* Additional CalSCHLS Fees */}
          <>
            <TableRow style={{ borderBottom: 'none', marginBottom: '5px' }}>

              <TableCell className='tableRow1Text' ref={el => {
                if (el) {
                  el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                }
              }}
                style={{ fontSize: '1.2em', fontWeight: '400', color: '#003c68', borderBottom: 'none' }}>
                Additional CalSCHLS Fees
              </TableCell>
            </TableRow >

            {
              (costEstimateData && costEstimateData.costestimateData) ?
                costEstimateData.costestimateData["Additional CalSCHLS Fees"].map((innerElement, index) => (

                  <TableRow key={index}>
                    <TableCell className='textColorTable' ref={el => { if (el) { el.style.setProperty('padding', '4px 9px 4px 40px', 'important'); } }} style={{ borderBottom: 'none', width: '30%' }}>
                      {innerElement['name']} 
                      {
                        authService.getRole() === 'admin' && localStorage.getItem("academicyear") === 'currentyear' ? (
                            <input value={(costEstimateData && costEstimateData.otherFessExtra) ? costEstimateData.otherFessExtra : ""} style={{ width: '60%', marginLeft: '12px', padding: '6px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '12px' }} autoComplete='off' type='text' name="otherFessExtra" onChange={handleOnChange} />
                        ) : (
                            <input value={(costEstimateData && costEstimateData.otherFessExtra) ? costEstimateData.otherFessExtra : ""} style={{ width: '60%', marginLeft: '12px', padding: '6px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '12px' }} autoComplete='off' type='text' name="otherFessExtra" disabled />
                        )
                      }
                    </TableCell> 
                    
                     
                    {authService.getRole() === 'admin' ? (
                    <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 45px', 'important'); } }} style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }} >
                      {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input value={innerElement['value']} headerdata="Additional CalSCHLS Fees" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        ) : (
                          <input disabled value={innerElement['value']} headerdata="Additional CalSCHLS Fees" datatype="value" name={innerElement['name']} className='inputForTable_ceQuan' type='text' onChange={handleCSOnChange} />
                        )}
                        </TableCell>
                      ) : (
                        <TableCell ref={el => { if (el) { el.style.setProperty('padding', '4px 13% 0px 10px', 'important'); } }} style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }} >
                          <span>{innerElement['value']}</span>
                        </TableCell>
                      )}
                

                    {authService.getRole() === 'admin' ? (
                      <TableCell
                        ref={el => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                          }
                        }}
                        style={{ borderBottom: 'none', width: '26%', textAlign: 'center' }}
                      >
                        <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }} >
                          $
                        </span>
                        {localStorage.getItem("academicyear") === 'currentyear' ? (
                          <input value={innerElement['unitPrice']} headerdata="Additional CalSCHLS Fees" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                        ) : (
                          <input disabled value={innerElement['unitPrice']} headerdata="Additional CalSCHLS Fees" datatype="unitPrice" name={innerElement['name']} className='inputForTable_ceUP' type='text' onChange={handleCSOnChange} />
                        )}
                      </TableCell>
                    ) : (
                      <TableCell
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty('padding', '4px 9px', 'important');
                            el.style.setProperty('margin', '0px auto', 'important');
                          }
                        }}
                        style={{
                          borderBottom: 'none',
                          width: '15.5%',
                          textAlign: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                          <div style={{ width: '60%', position: 'relative', bottom: '1px' }}>
                            <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                          </div>
                          <div style={{ width: '40%', textAlign: 'right' }}>
                            <span
                              style={{
                                textAlign: 'right',
                                marginLeft: '5px',
                                flex: '1',
                                minWidth: '0',
                              }}
                            >
                              {innerElement['unitPrice']}
                            </span>
                          </div>
                          <div>
                            <span
                              style={{
                                width: '40%',
                                fontWeight: '400',
                                color: 'black',
                                whiteSpace: 'nowrap',
                                textAlign: 'right',
                                marginRight: '2px',
                                position: 'relative',
                                top: '2px',
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </TableCell>
                    )}

                    <TableCell
                      ref={el => {
                        if (el) {
                          el.style.setProperty('padding', '4px 9px', 'important');
                        }
                      }}
                      style={{ borderBottom: 'none', width: '15.5%', textAlign: 'center' }}>

                      <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                        <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                        </div>
                        <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                          <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>

                ))
                : ""
            }
          </>

        </Table>
      </TableContainer>

      <TableContainer>
        <Table>
          <TableRow className='totalAmount'>

            <TableCell style={{ width: '77.6%' }} className='reduceWidth'>
              <span className='totalText' style={{ width: '100%' }}>Total Costs</span>
            </TableCell>

            <TableCell style={{ width: '15.4%' }} className='reduceWidth'>
              <span className='totalText' style={{ width: '100%' }}>
                <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                  <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                  </div>
                  <div style={{ width: '40%', textAlign: 'right' }}>
                    {/* {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)} */}
                    {total.toFixed(2)}
                  </div>
                  <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                  </div>

                </div>
              </span>
            </TableCell>

          </TableRow>

          <TableRow>
            <TableCell style={{ padding: '10px 0 5px 13px', borderBottom: 'none' }} >
              <div className='calSchls'>CalSCHLS Credits</div>
            </TableCell>
          </TableRow>

          {(costEstimateData && costEstimateData.costestimateData) ?
            costEstimateData.costestimateData["CalSCHLS Credits"].map((innerElement, index) => (
              <TableRow key={index}>

                <TableCell style={{ width: '77.6%', borderBottom: 'none', padding: innerElement.name == 'Other Credit' ? '3px 10px 13px 10px' : '3px 10px ' }} >
                  <span className='feeCreditText' style={{ width: '100%' }}>
                    {innerElement.name}
                  </span>
                </TableCell>


                 {authService.getRole() === 'admin' ? (
                  <TableCell style={{ width: '15.5%', borderBottom: 'none' }} className="reducePadd">
                 
                    <span style={{ width: '100%' }}>
                      <div
                        id="main"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          style={{
                            width: '20px', // Fixed width for the dollar sign
                            textAlign: 'center',
                            fontWeight: '400',
                            color: 'black',
                            position: 'relative',
                          }}
                        >
                          $
                        </div>
                        <div
                          style={{
                            width: '60px', // Fixed width for the input box
                            textAlign: 'left',
                          }}
                        >
                          {localStorage.getItem('academicyear') === 'currentyear' ? (
                            <input
                              value={innerElement['value']}
                              headerdata="CalSCHLS Credits"
                              datatype="value"
                              name={innerElement['name']}
                              className="inputForTable_ce_feeCredit"
                              type="text"
                              maxLength="8"
                              onChange={handleCSOnChange}
                              style={{ width: '50px' }}
                            />
                          ) : (
                            <input
                              value={innerElement['value']}
                              headerdata="CalSCHLS Credits"
                              datatype="value"
                              name={innerElement['name']}
                              className="inputForTable_ce_feeCredit"
                              type="text"
                              style={{ width: '50px' }}
                              disabled
                            />
                          )}
                        </div>
                      </div>
                    </span></TableCell>
                  ) : (
                    <TableCell
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty('padding', '4px 9px', 'important');
                          el.style.setProperty('margin', '0px auto', 'important');
                        }
                      }}
                      style={{
                        borderBottom: 'none',
                        width: '15.5%',
                        textAlign: 'center'
                      }}
                    >
                      <div
                        style={{
                          display: "flex", flexDirection: 'row-reverse'
                        }}
                      >
                      <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                        <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                      </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
          
                          {innerElement['unitPrice']}
                        </div>
                        <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                        <span
                          style={{
                            fontWeight: '400',
                            color: 'black',
                            whiteSpace: 'nowrap',
                            textAlign: 'right',
                            marginRight: '2px',
                            position: 'relative',
                            top: '2px',
                          }}
                        >
                          $
                        </span>
                        </div>
                      </div>
                    </TableCell>
                  )}

              </TableRow>
            ))
            : ""}

          <TableRow className='totalAmount '>

            <TableCell style={{ width: '77.6%' }} className='reduceWidth'>
              <span className='totalText' style={{ width: '100%' }}>Total Amount Due</span>
            </TableCell>

            <TableCell style={{ width: '15.4%' }} className='reduceWidth'>
              <span className='totalText' style={{ width: '100%' }}>
  
                <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>
                  <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                  </div>
                  <div style={{ width: '40%', textAlign: 'right' }}>
                    {(total - credit).toFixed(2)}
                  </div>
                  <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                    <span style={{ marginRight: '2px', fontWeight: '400', color: 'black', position: 'relative', top: '2px' }}>$</span>
                  </div>
                </div>
              </span>
            </TableCell>
          </TableRow>



          <TableRow>
            <div className='amountDetails'>If you have any questions about this quote, please email <span style={{ color: 'blue' }}> calschls@wested.org</span>.</div>
          </TableRow>

        </Table>
      </TableContainer>
      {authService.getRole() === 'admin' ? (
        localStorage.getItem("academicyear") === 'currentyear' ? (
          <div id="buttonDiv" style={{ margin: '10px' }} >
            <Button variant="contained" className='buttonText' onClick={saveCostEstimateData} disabled={emailError} >Save</Button>
          </div>
        ) : null
      ) : null}
      {/* {authService.getRole() == 'admin' ?
            <div style={{ margin: '10px' }}>
              <Button variant="contained" className='buttonText' onClick={saveCostEstimateData}> Save</Button>
            </div> : ''
          } */}


      {/* </div> */}



    </Item >

      </Grid >
    </>
  )
}

export default CostEstimate